import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';
import {
  RESTRICTED_SITE_ADMIN,
  SITE_ADMIN,
} from '../../../lib/utils/constants/UserTypes';

export default function Account({
  userType,
  setShowDropdown,
  showDropdown,
  dropdownRef,
}) {
  const { t } = useTranslation('header');

  return (
    <AccountWrapper
      id="accountDropdown"
      style={{ position: 'relative' }}
      onClick={() => setShowDropdown(state => !state)}
      data-tip="Account"
      data-for="Account"
    >
      <i className="fa-regular fa-circle-user fa-xl"></i>
      {showDropdown && (
        <List ref={dropdownRef}>
          <Link href="/account/settings/edit">
            <Option>{t('account.settings')}</Option>
          </Link>
          {[SITE_ADMIN, RESTRICTED_SITE_ADMIN].includes(userType) && (
            <Link href="/admin">
              <Option>{t('account.siteAdmin')}</Option>
            </Link>
          )}
          <Link
            id="signOut"
            rel="nofollow"
            data-method="delete"
            href="/sign_out"
          >
            <SignOut>{t('account.signOut')}</SignOut>
          </Link>
        </List>
      )}
    </AccountWrapper>
  );
}

Account.propTypes = {
  userType: PropTypes.string,
  setShowDropdown: PropTypes.func,
  showDropdown: PropTypes.bool,
  dropdownRef: PropTypes.object,
};

const AccountWrapper = styled.div`
  display: none;

  ${themeGet('mediaQueries.forMediumUp')} {
    display: block;
    cursor: pointer;
    border-radius: 40px;
    padding: 3px;
    &:hover {
      .fa-circle-user {
        color: ${themeGet('colors.black.60')};
      }
    }
  }
`;

const List = styled.ul`
  position: absolute;
  top: 51px;
  right: 0;
  border-radius: 8px;
  background: white;
  z-index: 4;
  width: 200px;
  font-weight: 500;
  font-size: 14px;
  box-shadow: 0px 0px 8px rgba(37, 40, 43, 0.12);
  max-height: 80vh;
  overflow-y: auto;
`;

const Li = styled.li`
  cursor: pointer;
  width: 100%;

  &:hover {
    background: rgba(229, 242, 255, 0.5);
  }
`;

const Option = styled(Li)`
  padding: 16px 20px 16px;
`;

const SignOut = styled(Li)`
  border-top: 1px solid ${themeGet('colors.black.20')};
  padding: 16px 20px 16px;
`;

const Link = styled.a`
  color: ${themeGet('colors.black.80')};

  &:hover,
  &:visited {
    color: ${themeGet('colors.black.80')};
  }
`;
